<template>
  <f-dashboard-content-wrapper>
    <f-loader v-if="code === undefined"></f-loader>
    
      <code-card
        v-if="code"
        class="m-bottom-20"
        :id="code._id"
      ></code-card>

      <div class="max-width-500 is-margin-auto">
        <code-infos 
          v-if="code"
          :id="codeId"
        ></code-infos>
      </div>
  </f-dashboard-content-wrapper>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import { useDate, formatDate } from '@composables/use-date'
  import router from '@core/router'
  import useRoles from '@composables/use-roles'
  import CodeCard from '@components/codes/view/code-card'
  import CodeInfos from '@components/codes/edit-infos'

  export default {
    async setup () {
     const codeId = computed(() => router.currentRoute.value.params.id)
      const { get, fetch, patch, remove } = useStore('@freebe/codes')
      const { checkPermissions } = useRoles()

      if (!checkPermissions('freebe/pricing/codes:get')) {
        router.replace({ name: 'home' })
      }
      
      const code = computed(() =>
        get(codeId.value)
      )

      if (!code.value) {
        await fetch(codeId.value)        
      }

      return {
        code,
        codeId
      }
    },

    components: {
      CodeCard,
      CodeInfos
    },
  }
</script>